module.exports = __webpack_public_path__ + "static/media/oly-large-catalog-list-lg.2a3c1e56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Olympic/oly-large-catalog-list-lg.jpg
// module id = 660
// module chunks = 0